import { useHistory } from 'react-router-dom';
import Button from '../Button';
import styles from './MiddleSchoolBackButton.module.scss';
import { Icon } from '@iconify/react';
import arrowIosBackOutline from '@iconify/icons-eva/arrow-ios-back-outline';

const MiddleSchoolBackButton = (): JSX.Element => {
  const history = useHistory();
  return (
    <div className={styles.container}>
      <Button onClick={() => history.push('/studentportal/ToDos')}>
        <Icon icon={arrowIosBackOutline} width={30} />
      </Button>
    </div>
  );
};

export default MiddleSchoolBackButton;
